import { useQuery } from '@tanstack/react-query';
import { getAllItems } from '../../api/api';
import { Loader2, Package, User, Clock, DollarSign } from 'lucide-react';
import { useLanguage } from '../../contexts/LanguageContext';

const ItemsTable = () => {
    const { t } = useLanguage();
    const { data: items = [], isLoading } = useQuery({ queryKey: ['admin', 'items'], queryFn: getAllItems });

    if(isLoading) return (
        <div className="flex justify-center p-12">
            <Loader2 className="animate-spin w-8 h-8 text-primary" />
        </div>
    );
    
    return (
        <div className="overflow-x-auto bg-card rounded-xl border border-border shadow-sm">
            <table className="min-w-full divide-y divide-border">
                <thead className="bg-muted/50">
                    <tr>
                        <th className="px-6 py-3 text-left text-xs font-black uppercase tracking-widest text-muted-foreground">{t('title')}</th>
                        <th className="px-6 py-3 text-left text-xs font-black uppercase tracking-widest text-muted-foreground">{t('category')}</th>
                        <th className="px-6 py-3 text-left text-xs font-black uppercase tracking-widest text-muted-foreground">{t('status')}</th>
                        <th className="px-6 py-3 text-left text-xs font-black uppercase tracking-widest text-muted-foreground">{t('estimatedValue')}</th>
                        <th className="px-6 py-3 text-left text-xs font-black uppercase tracking-widest text-muted-foreground">{t('createdBy')}</th>
                    </tr>
                </thead>
                <tbody className="divide-y divide-border">
                    {items.length === 0 ? (
                        <tr><td colSpan="5" className="px-6 py-12 text-center text-muted-foreground">{t('noItemsFoundMatching')}</td></tr>
                    ) : items.map(item => (
                        <tr key={item._id} className="hover:bg-muted/30 transition-colors">
                            <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center gap-3">
                                    {item.images?.[0] ? (
                                        <img src={item.images[0]} alt={item.title} className="w-10 h-10 rounded-lg object-cover border border-border" />
                                    ) : (
                                        <div className="w-10 h-10 rounded-lg bg-muted flex items-center justify-center text-muted-foreground">
                                            <Package size={16} />
                                        </div>
                                    )}
                                    <span className="text-sm font-bold truncate max-w-[200px]">{item.title}</span>
                                </div>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-muted-foreground uppercase font-bold text-[10px] tracking-tighter">
                                {item.category}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                                <span className={`px-2 py-1 rounded-full text-[10px] font-black uppercase tracking-tighter ${
                                    item.status === 'active' ? 'bg-green-500/10 text-green-600' : 'bg-yellow-500/10 text-yellow-600'
                                }`}>
                                    {t(item.status)}
                                </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-black text-primary">
                                ${item.estimated_value?.toLocaleString()}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-xs text-muted-foreground">
                                <div className="flex flex-col">
                                    <span className="font-bold text-foreground">{item.seller_full_name}</span>
                                    <span className="opacity-70 text-[10px]">{item.created_by}</span>
                                </div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

export default ItemsTable;
